module.exports = __webpack_public_path__ + "3f0ff29edec1683ed6bb4c34181da662.svg";